import { createInjectionKey as n } from "./ghl-ui.es896.js";
const i = n("n-loading-bar"), a = n("n-loading-bar-api");
export {
  a as loadingBarApiInjectionKey,
  i as loadingBarProviderInjectionKey
};
